import { render, staticRenderFns } from "./List_project.vue?vue&type=template&id=2e4d8387&scoped=true&"
import script from "./List_project.vue?vue&type=script&lang=js&"
export * from "./List_project.vue?vue&type=script&lang=js&"
import style0 from "./List_project.vue?vue&type=style&index=0&id=2e4d8387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d8387",
  null
  
)

export default component.exports